import type { DateTime } from "luxon";

export function formatApiDate(date: DateTime) {
  return date.toFormat("yyyyLLddHHmmss");
}
